import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import { allowedRootTypesMap, searchAndFilterFolders } from './constants';
import { EPlateState } from 'enums/EPlatestate';
import ETreeNodeAccessRightNames from 'enums/ETreeNodeAccessRightNames';

export const isPasteAllowedForRootNodes = (treeControlState, nodesToCopy) => {
  if (nodesToCopy.length === 0) {
    return false;
  }

  const selectedType = treeControlState.selectedNodes[0]?.type as ETreeNodeTypes;
  const allowedTypes = allowedRootTypesMap[selectedType];

  return allowedTypes
    ? nodesToCopy.every((node) => allowedTypes.includes(node.type as ETreeNodeTypes))
    : false;
};

export const isImageNowDisabled = (isRMLite, selectedNodes) => {
  return (
    isRMLite ||
    !selectedNodes.every((node) => node.type === 'Experiment') ||
    selectedNodes.some((node) => node.extra?.plateState < EPlateState.Dispensed)
  );
};

export const isNewSnfDisabled = (selectedExplorerNode, isPlateViewerEdition: boolean = false) => {
  return (
    selectedExplorerNode?.accessRightName !== ETreeNodeAccessRightNames.Modify ||
    !searchAndFilterFolders.includes(selectedExplorerNode?.type) ||
    !selectedExplorerNode?.allowEdits ||
    isPlateViewerEdition
  );
};
